export { default as HUIPageHeader } from './hui-page-header';
export type { HUIPageHeaderProps } from './types';
